export default __webpack_public_path__ + "icon-jobs.eef82fa0003c2e7aa01369fbc40233e9.svg";